import opnModal from '../actions/openModal'
import opnNodeInfoModal from '../actions/openNodeInfoModal'
export default [
  opnNodeInfoModal,
  opnModal
]
